module.exports = __webpack_public_path__ + "static/media/body_bg1.1c63b324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/body_bg1.jpg
// module id = 1581
// module chunks = 10